import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBill = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M8.5 10.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm6 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-.97-4.97a.75.75 0 1 0-1.06-1.06l-6 6a.75.75 0 1 0 1.06 1.06l6-6Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M17.75 3a.75.75 0 0 0-1.143-.639l-2.879 1.77-3.198-1.786a.75.75 0 0 0-.731 0L6.582 4.141 3.366 2.345A.75.75 0 0 0 2.25 3v18c0 .414.336.75.75.75h16.043A2.75 2.75 0 0 0 21.75 19v-6.571c0-.651-.528-1.179-1.179-1.179H17.75V3Zm-1.5 9.429V4.34L14.14 5.64a.75.75 0 0 1-.759.016l-3.217-1.796-3.216 1.796a.75.75 0 0 1-.731 0L3.75 4.278V20.25h12.8c-.192-.375-.3-.8-.3-1.25v-6.571ZM19 20.25c.69 0 1.25-.56 1.25-1.25v-6.25h-2.5V19c0 .69.56 1.25 1.25 1.25Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorBill;
